import React from 'react';
import { urlApi } from '../Constants/Global';

import SectionHeader from '../Components/SectionHeader';
import SectionCarousel from '../Components/SectionCarousel';
import SectionContact from '../Components/SectionContact';
import Bg from '../Medias/Photos/photo-bg7.jpg';
import SectionTeam from '../Components/SectionTeam';

const OurTeam = ({ contents }) => {
  console.log(contents)

  return (
    <>
      <SectionHeader topic='Our Team' detail={<span style={{fontSize: '18px'}}>The PTA team is guided by our core values of a dynamic, commercially-focused approach. It is ingrained in our "DNA" to go beyond mere legal texts and technical details, ensuring a comprehensive understanding of each project. With a blend of seasoned and energetic professionals, our team is prepared to provide practical, dependable legal solutions tailored to our clients' needs.</span>} bg={Bg} textSize={10} />
      <SectionTeam hideTopic={true} bgColor="bg-white" />
    </>
  )
}

OurTeam.defaultProps = {
  contents: {
    lang: 'th',
    content: {
      contents: []
    }
  },
  web_setup: {
    practice_topic: [],
    practice: []
  },
  path: '',
  lang: 'en'
}

export default OurTeam